module.exports = __webpack_public_path__ + "img/color-palette.9b9077b0.svg";